import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const ConditionForm = () => {
  const [conditionName, setConditionName] = useState('');
  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Neues Feld: loConditionId und sortOrder
  const [newLoConditionId, setNewLoConditionId] = useState('');
  const [newSortOrder, setNewSortOrder] = useState('');

  // Bearbeitungs‑States
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [editedLoConditionId, setEditedLoConditionId] = useState('');
  const [editedSortOrder, setEditedSortOrder] = useState('');

  // Laden & Sortieren
  const fetchConditions = async () => {
    try {
      const response = await api.get('/conditions');
      const sorted = response.data.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      setConditions(sorted);
    } catch (error) {
      console.error('Fehler beim Laden der Conditions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConditions();
  }, []);

  // Hinzufügen
  const handleAddCondition = async () => {
    if (!conditionName) {
      alert('Bitte einen Namen für die Condition eingeben!');
      return;
    }
    try {
      await api.post('/conditions', {
        name: conditionName,
        loConditionId: newLoConditionId || null,
        sortOrder: newSortOrder ? parseInt(newSortOrder, 10) : 0
      });
      setConditionName('');
      setNewLoConditionId('');
      setNewSortOrder('');
      fetchConditions();
    } catch (error) {
      console.error('Fehler beim Hinzufügen der Condition:', error);
      alert('Fehler beim Hinzufügen der Condition');
    }
  };

  // Löschen
  const handleDeleteCondition = async (id) => {
    try {
      await api.delete(`/conditions/${id}`);
      setConditions(conditions.filter(c => c.id !== id));
      alert('Condition gelöscht!');
    } catch (error) {
      console.error('Fehler beim Löschen der Condition:', error);
      alert('Fehler beim Löschen der Condition');
    }
  };

  // Bearbeiten starten
  const handleEditCondition = (cond) => {
    setEditingId(cond.id);
    setEditedName(cond.name);
    setEditedLoConditionId(cond.loConditionId || '');
    setEditedSortOrder(cond.sortOrder !== undefined ? cond.sortOrder : '');
  };

  // Bearbeiten abbrechen
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedName('');
    setEditedLoConditionId('');
    setEditedSortOrder('');
  };

  // Aktualisieren
  const handleUpdateCondition = async (id) => {
    try {
      await api.put(`/conditions/${id}`, {
        name: editedName,
        loConditionId: editedLoConditionId || null,
        sortOrder: editedSortOrder ? parseInt(editedSortOrder, 10) : 0
      });
      setEditingId(null);
      fetchConditions();
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Condition:', error);
      alert('Fehler beim Aktualisieren der Condition: ' + error.message);
    }
  };

  if (loading) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '800px' }}>
        <Helmet>
          <title>Conditions bearbeiten</title>
          <meta name="description" content="Conditions bearbeiten" />
        </Helmet>

        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Conditions verwalten</h2>

        {/* Hinzufügen-Formular */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr auto',
          gap: '10px',
          marginBottom: '20px',
          alignItems: 'center'
        }}>
          <input
            type="text"
            value={conditionName}
            onChange={e => setConditionName(e.target.value)}
            placeholder="Name"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="text"
            value={newLoConditionId}
            onChange={e => setNewLoConditionId(e.target.value)}
            placeholder="loConditionId"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="number"
            value={newSortOrder}
            onChange={e => setNewSortOrder(e.target.value)}
            placeholder="Sort"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <button
            onClick={handleAddCondition}
            style={{
              padding: '6px 12px',
              background: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '-15px'
            }}
          >
            Hinzufügen
          </button>
        </div>

        {/* Listenansicht */}
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {conditions.map(cond => (
            <li
              key={cond.id}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr auto',
                gap: '10px',
                alignItems: 'center',
                padding: '8px 0',
                borderBottom: '1px solid #ddd'
              }}
            >
              {editingId === cond.id ? (
                <>
                  <input
                    type="text"
                    value={editedName}
                    onChange={e => setEditedName(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="text"
                    value={editedLoConditionId}
                    onChange={e => setEditedLoConditionId(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="number"
                    value={editedSortOrder}
                    onChange={e => setEditedSortOrder(e.target.value)}
                    placeholder="Sort"
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <div>
                    <button onClick={() => handleUpdateCondition(cond.id)} style={{ marginRight: '5px' }}>✅</button>
                    <button onClick={handleCancelEdit}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  <span>{cond.name}</span>
                  <span>{cond.loConditionId}</span>
                  <span>{cond.sortOrder}</span>
                  <div>
                    <button onClick={() => handleEditCondition(cond)} style={{
                      fontSize: '15px',
                      padding: '5px 10px',
                      background: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      marginRight: '5px',
                    }}>
                      Bearbeiten
                    </button>
                    <button onClick={() => handleDeleteCondition(cond.id)}
                      style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#dc3545',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}>
                      Löschen
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ConditionForm;
